import type { ReactNode } from 'react'
import { AddPlanToCartButtonProduct } from '../../AddPlanToCartButton'

type Props = {
  readonly children: ReactNode
  readonly onClick: () => void
  readonly sku: string
  readonly showCartCTA?: boolean
}

/**
 * Footer component. Renders the Add to Cart button if showCartCTA is true or free trial text if showCartCTA is false
 *
 * @param onClick - The onClick handler for the Add to Cart button tracking event
 * @param sku - The SKU for the plan
 * @param showCartCTA - Whether to show the Add to Cart button
 * @returns JSX.Element | null
 */
export function Footer({ children, onClick, showCartCTA = true, sku }: Props) {
  return (
    <div className="flex justify-between items-center px-6 py-4 md:py-4">
      {children}
      {showCartCTA ? (
        <AddPlanToCartButtonProduct
          buttonText="Add free month"
          className="mt-2 block !text-sm md:!text-lg"
          onClick={onClick}
          quantity={1}
          sku={sku}
        />
      ) : (
        <div className="prose-p:mb-0 text-right text-base">
          <p>Free trial.</p>
          <p>No contract.</p>
          <p>Cancel any time.</p>
        </div>
      )}
    </div>
  )
}
